import { useState } from 'react'
import classnames from 'classnames'

import {
  isImageFitTypeContainAll,
  isImageFitTypeContainVertical,
} from '../../../utils/file'

import * as styles from './FilePreviewImage.module.css'

function FilePreviewImage({
  ErrorImagePreview,
  alt,
  children,
  className,
  errorPreviewImageProps,
  filename,
  fileSize,
  filled,
  fit,
  imageClassName = styles.img,
  sizes,
  src,
  srcSet,
  onClick,
  onError,
}) {
  const [showError, setShowError] = useState(false)

  function handleError() {
    setShowError(true)

    onError?.()
  }

  const boxClass = classnames(styles.FilePreviewImage, className)

  const imgClass = classnames(
    {
      [styles.contain]: isImageFitTypeContainAll(fit),
      [styles.vertical]: isImageFitTypeContainVertical(fit),
    },
    imageClassName
  )

  return showError && ErrorImagePreview ? (
    <ErrorImagePreview
      {...errorPreviewImageProps}
      filename={filename}
      fileSize={fileSize}
    />
  ) : (
    <>
      {filled ? (
        <img
          alt={alt || filename}
          className={styles.fill}
          src={src}
          onError={handleError}
        />
      ) : null}
      <div className={boxClass} onClick={onClick}>
        <img
          alt={alt || filename}
          className={imgClass}
          sizes={sizes}
          src={src}
          srcSet={srcSet}
          onError={handleError}
        />
        {children}
      </div>
    </>
  )
}

export default FilePreviewImage
